/**
 * assetUrl.js
 *
 * Returns the full URL for a public asset path.
 *
 * In production (when REACT_APP_CDN_BASE_URL is set), assets are served from
 * Azure Blob Storage via Azure CDN instead of the Static Web App bundle.
 * In local development (no env var) the path is returned as-is, resolved
 * against /public/ by the webpack dev server.
 *
 * Usage:
 *   assetUrl('/assets/audio/bell.mp3')
 *   // dev  → '/assets/audio/bell.mp3'
 *   // prod → 'https://<name>.azureedge.net/assets/audio/bell.mp3'
 *
 * Setup:
 *   Add REACT_APP_CDN_BASE_URL=https://<your-cdn>.azureedge.net to:
 *     - .env.production  (local production builds)
 *     - Azure Static Web Apps application settings (deployed env)
 */

const CDN_BASE = (process.env.REACT_APP_CDN_BASE_URL || '').replace(/\/$/, '');

/**
 * @param {string} path - Asset path starting with '/', e.g. '/assets/audio/foo.mp3'
 * @returns {string} Full URL — CDN-prefixed in production, relative in dev
 */
export function assetUrl(path) {
  if (!CDN_BASE) return path;
  return `${CDN_BASE}${path}`;
}
